// extracted by mini-css-extract-plugin
module.exports = {"blackNextButton":"styles_blackNextButton__2zTxd","ant-btn-primary":"styles_ant-btn-primary__colkQ"};